import api from './api';

export default async function getKeywords(pageNumber=0, pageSize=10, searchTerm=null) {

    const { data } = await api.get(`misspelling-keyword?page-number=${pageNumber}&page-size=${pageSize}&text=${searchTerm}`);

    return data;
}